import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const footerHelper = css`
  min-height: calc(100vh - 103rem);

  @media (min-width: ${dimensions.tablet}) {
    min-height: calc(100vh - 65rem);
  }

  @media (min-width: ${dimensions.desktop}) {
    min-height: calc(100vh - 43rem);
  }
`;

export const spacer = css`
  padding-top: 4.75rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    padding-top: 0;
  }
`;
